import React, { Component } from 'react';
import { Form, Col } from 'react-bootstrap';
import Select from 'react-select';
import { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import {
    relationType,
    serviceOptions,
    comOptns,
    schoolCityOptns,
    rehabCityOptns,
    en_relationType,
    en_serviceOptions,
    en_comOptns,
    en_schoolCityOptns,
    en_rehabCityOptns,
    colourStyles,
    dangerStyles,
} from './Options';
import Stepper from './Stepper';
import { api_url } from '../../common/config';
// import { DatePicker } from '@y0c/react-datepicker';
import 'react-nice-dates/build/style.css';
import '@y0c/react-datepicker/assets/styles/calendar.scss';
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker from 'react-modern-calendar-datepicker';
import { utils } from 'react-modern-calendar-datepicker';
// import DatePicker from 'react-date-picker';

const name = /^[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z ]+[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z-_ ]*$/;
const nameNumber = /^[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z ]+[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z-_ /d]*$/;
const mobile = /(^(\+\d{1,3}[- ]?)?\d{10}$)|(^(\+[\u0660-\u0669]{1,3}[- ]?)?[\u0660-\u0669]{10}$)/;
const email = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
const id = /(^\d{10}$)|(^[\u0660-\u0669]{10}$)/;
const dateReg = /^\d{4}[\/.-]\d{1,2}[\/.-]\d{1,2}$/;

const Input = ({ type, name, label, value, onChange, empty }) => {
    return (
        <div
            className={`${
                i18next.language === 'ar'
                    ? 'tb-container'
                    : 'tb-container text-left ml-0'
            }`}
        >
            <input
                className={`aumd-tb ${empty === true ? 'aumd-tb-d' : ''}`}
                id={name}
                name={name}
                type={type}
                placeholder=' '
                value={value}
                onChange={onChange}
            />
            <label
                className={`${
                    i18next.language === 'ar'
                        ? 'aumd-tb-label'
                        : 'en-aumd-tb-label'
                }`}
                for={name}
            >
                {label}
            </label>
            <span className={`validation ${empty === true ? 'vd' : ''}`}>
                valid
            </span>
        </div>
    );
};

const InvalidInput = ({ type, name, label, value, onChange, empty }) => {
    return (
        <>
            <div
                className={`${
                    i18next.language === 'ar'
                        ? 'tb-container'
                        : 'tb-container text-left ml-0'
                }`}
            >
                <input
                    className={`aumd-tb-invalid ${
                        empty === true ? 'aumd-tb-d' : ''
                    }`}
                    id={name}
                    name={name}
                    type={type}
                    placeholder=' '
                    value={value}
                    onChange={onChange}
                />
                <label
                    className={`${
                        i18next.language === 'ar'
                            ? 'aumd-tb-label-invalid'
                            : 'en-aumd-tb-label-invalid'
                    }`}
                    for={name}
                >
                    {label}
                </label>
                <span
                    className={`validation ${empty === true ? 'vd' : ''}`}
                ></span>
            </div>
        </>
    );
};

class Child extends Component {
    constructor(props) {
        super(props);

        this.state = {
            step: 1,
            pageEnd: 4,
            title: [
                `${this.props.t('register.child.pageTitle.contact')}`,
                `${this.props.t('register.child.pageTitle.familyInfo')}`,
                `${this.props.t('register.child.pageTitle.childMedInfo')}`,
                `${this.props.t('register.child.pageTitle.services')}`,
            ],
            done: [10, 30, 60, 100],
            left: [90, 70, 40, 0],
            salary: [3500, 7000],
            guardianName: '',
            guardianNameValid: true,
            mobileNum: '',
            mobileNumValid: true,
            altMobileNum: '',
            altMobileNumValid: true,
            guardianID: '',
            guardianIDValid: true,
            guardianNationality: '',
            guardianNationalityEmpty: false,
            emailAddress: '',
            emailAddressValid: true,
            email: false,
            sms: false,
            phone: false,
            relation: '',
            relationLabel: '',
            childName: '',
            childNameValid: true,
            childBirth: '',
            childBirthEmpty: false,
            nationality: '',
            nationalityEmpty: false,
            residenceLoc: '',
            residenceLocValid: true,
            childID: '',
            childIDValid: true,
            familySize: '',
            serviceType: '',
            serviceTypeLabel: '',
            comType: '',
            comTypeEmpty: false,
            comTypeLabel: '',
            rehabCity: '',
            rehabCityLabel: '',
            schoolCity: '',
            schoolCityLabel: '',
            genderOpt: '',
            genderOptEmpty: false,
            diagnosysOpt: '',
            diagnosysOptEmpty: false,
            currentServicesOpt: '',
            currentServicesOptEmpty: false,
            attendingSchool: '',
            attendingSchoolEmpty: false,
            hearingCheckOpt: '',
            hearingCheckEmpty: false,
            hearingResultOpt: '',
            hearingResultOptEmpty: false,
            restroomDependencyOpt: '',
            restroomDependencyOptEmpty: false,
            rehabLocation: '',
            rehabLocationValid: true,
            schoolName: '',
            schoolNameValid: true,
            isValid: true,
            emptyField: false,
            emptyFirst: false,
            emptySecond: false,
            emptyThird: false,
            emptyFourth: false,
            relationEmpty: false,
            send: false,
            who: '',
            whoValid: true,
            transportationOpt: '',
            transportationOptEmpty: false,
            childAge: '',
            error: false,
            sendClicked: false,
            optional: false,
            date: new Date(),
        };
    }

    onChangeHandler = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            emptyField: false,
        });
    };

    onSelect = (e) => {
        switch (e.type) {
            case 'rel':
                this.setState({
                    relation: e.value,
                    relationLabel: e.label,
                });
                break;
            case 'schoolCity':
                this.setState({
                    schoolCity: e.value,
                    schoolCityLabel: e.label,
                });
                break;
            case 'rehabCity':
                this.setState({
                    rehabCity: e.value,
                    rehabCityLabel: e.label,
                });
                break;
            case 'service':
                this.setState({
                    serviceType: e.value,
                    serviceTypeLabel: e.label,
                });
                break;
            case 'com':
                this.setState({
                    comType: e.value,
                    comTypeLabel: e.label,
                });
                break;
            default:
        }

        this.setState({
            emptyField: false,
        });
    };

    onIncomeChange = (value) => {
        this.setState({
            salary: [value[0], value[1]],
        });
    };

    onDateChange = (date) => {
        if (typeof date === 'object' && date !== null) {
            this.setState({
                childBirth: date.format('YYYY-MM-DD'),
                childBirthEmpty: false,
            });
        } else if (dateReg.test(date)) {
            this.setState({
                childBirth: date,
                childBirthEmpty: false,
            });
        } else {
            console.log('Invalid Date');
        }
    };

    checkNotEmpty = () => {
        const {
            step,
            guardianName,
            mobileNum,
            altMobileNum,
            guardianID,
            emailAddress,
            relation,
            childName,
            childBirth,
            nationality,
            residenceLoc,
            childID,
            familySize,
            genderOpt,
            guardianNationality,
            who,
            childAge,
            comType,
            attendingSchool,
            currentServicesOpt,
        } = this.state;

        if (step === 1) {
            this.relationEmpty();
            this.guardianNationality();
            if (
                guardianName !== '' &&
                guardianID !== '' &&
                emailAddress !== '' &&
                relation !== '' &&
                mobileNum !== '' &&
                altMobileNum !== '' &&
                guardianNationality !== ''
            ) {
                this.setState({
                    emptyFirst: false,
                });
                return true;
            } else {
                this.setState({
                    emptyFirst: true,
                });
                return false;
            }
        } else if (step === 2) {
            this.nationality();
            this.checkChildBirth();
            this.checkChildGender();
            if (
                childName !== '' &&
                childBirth !== '' &&
                childID !== '' &&
                genderOpt !== '' &&
                residenceLoc !== '' &&
                familySize !== '' &&
                nationality !== ''
            ) {
                this.setState({
                    emptySecond: false,
                });
                return true;
            } else {
                this.setState({
                    emptySecond: true,
                });
                return false;
            }
        } else if (step === 3) {
            this.checkDiagnosys();
            this.checkHearing();
            this.restroomDependency();
            this.transportation();
            this.comEmpty();
            if (
                this.checkDiagnosys() !== false &&
                this.checkHearing() !== false &&
                this.restroomDependency() !== false &&
                who !== '' &&
                this.transportation() !== false &&
                childAge !== '' &&
                comType !== ''
            ) {
                this.setState({
                    emptyThird: false,
                });
                return true;
            } else {
                this.setState({
                    emptyThird: true,
                });
                return false;
            }
        } else if (step === 4) {
            this.attendingEmpty();
            this.servicesEmpty();
            if (attendingSchool !== '' && currentServicesOpt !== '') {
                this.setState({
                    emptyFourth: false,
                });
                return true;
            } else {
                this.setState({
                    emptyFourth: true,
                });
                return false;
            }
        }
    };

    checkChildBirth = () => {
        if (this.state.childBirth !== '') {
            return true;
        } else {
            this.setState({
                childBirthEmpty: true,
            });
            return false;
        }
    };

    attendingEmpty = () => {
        if (this.state.attendingSchool !== '') {
            return true;
        } else {
            this.setState({
                attendingSchoolEmpty: true,
            });
            return false;
        }
    };

    servicesEmpty = () => {
        if (this.state.currentServicesOpt !== '') {
            return true;
        } else {
            this.setState({
                currentServicesOptEmpty: true,
            });
            return false;
        }
    };

    checkChildGender = () => {
        if (this.state.genderOpt !== '') {
            return true;
        } else {
            this.setState({
                genderOptEmpty: true,
            });
            return false;
        }
    };

    relationEmpty = () => {
        if (this.state.relation !== '') {
            this.setState({
                relationEmpty: false,
            });
            return true;
        } else {
            this.setState({
                relationEmpty: true,
            });
            return false;
        }
    };

    comEmpty = () => {
        if (this.state.comType !== '') {
            this.setState({
                comTypeEmpty: false,
            });
            return true;
        } else {
            this.setState({
                comTypeEmpty: true,
            });
            return false;
        }
    };

    checkDiagnosys = () => {
        if (this.state.diagnosysOpt !== '') {
            return true;
        } else {
            this.setState({
                diagnosysOptEmpty: true,
            });
            return false;
        }
    };

    checkHearing = () => {
        if (this.state.hearingCheckOpt !== '') {
            return true;
        } else {
            this.setState({
                hearingCheckEmpty: true,
            });
            return false;
        }
    };

    hearingResult = () => {
        if (this.state.hearingResultOpt !== '') {
            return true;
        } else {
            this.setState({
                hearingResultOptEmpty: true,
            });
            return false;
        }
    };

    guardianNationality = () => {
        if (this.state.guardianNationality !== '') {
            return true;
        } else {
            this.setState({
                guardianNationalityEmpty: true,
            });
            return false;
        }
    };

    nationality = () => {
        if (this.state.nationality !== '') {
            return true;
        } else {
            this.setState({
                nationalityEmpty: true,
            });
            return false;
        }
    };

    restroomDependency = () => {
        if (this.state.restroomDependencyOpt !== '') {
            return true;
        } else {
            this.setState({
                restroomDependencyOptEmpty: true,
            });
            return false;
        }
    };

    rehab = () => {
        if (this.state.currentServicesOpt !== '') {
            return true;
        } else {
            this.setState({
                currentServicesOptEmpty: true,
            });
            return false;
        }
    };

    school = () => {
        if (this.state.attendingSchool !== '') {
            return true;
        } else {
            this.setState({
                attendingSchoolEmpty: true,
            });
            return false;
        }
    };

    transportation = () => {
        if (this.state.transportationOpt !== '') {
            return true;
        } else {
            this.setState({
                transportationOptEmpty: true,
            });
            return false;
        }
    };

    sendEnable = (value) => {
        this.setState({
            sendClicked: value,
        });
    };

    validGuardianName = () => {
        if (name.test(this.state.guardianName) === true) {
            this.setState({
                guardianNameValid: true,
            });
        } else {
            this.setState({
                guardianNameValid: false,
            });
        }
    };

    validMobileNum = () => {
        if (mobile.test(this.state.mobileNum) === true) {
            this.setState({
                mobileNumValid: true,
            });
        } else {
            this.setState({
                mobileNumValid: false,
            });
        }
    };

    validAltMobileNum = () => {
        if (mobile.test(this.state.altMobileNum) === true) {
            this.setState({
                altMobileNumValid: true,
            });
        } else {
            this.setState({
                altMobileNumValid: false,
            });
        }
    };

    validEmailAddress = () => {
        if (email.test(this.state.emailAddress) === true) {
            this.setState({
                emailAddressValid: true,
            });
        } else {
            this.setState({
                emailAddressValid: false,
            });
        }
    };

    validGuardianID = () => {
        if (id.test(this.state.guardianID) === true) {
            this.setState({
                guardianIDValid: true,
            });
        } else {
            this.setState({
                guardianIDValid: false,
            });
        }
    };

    validChildName = () => {
        if (name.test(this.state.childName) === true) {
            this.setState({
                childNameValid: true,
            });
        } else {
            this.setState({
                childNameValid: false,
            });
        }
    };

    validResidenceLoc = () => {
        if (name.test(this.state.residenceLoc) === true) {
            this.setState({
                residenceLocValid: true,
            });
        } else {
            this.setState({
                residenceLocValid: false,
            });
        }
    };

    validChildID = () => {
        if (id.test(this.state.childID) === true) {
            this.setState({
                childIDValid: true,
            });
        } else {
            this.setState({
                childIDValid: false,
            });
        }
    };

    validWho = () => {
        if (name.test(this.state.who) === true) {
            this.setState({
                whoValid: true,
            });
        } else {
            this.setState({
                whoValid: false,
            });
        }
    };

    validSchoolName = () => {
        if (nameNumber.test(this.state.schoolName) === true) {
            this.setState({
                schoolNameValid: true,
            });
        } else {
            this.setState({
                schoolNameValid: false,
            });
        }
    };

    validRehabLoc = () => {
        if (name.test(this.state.rehabLocation) === true) {
            this.setState({
                rehabLocationValid: true,
            });
        } else {
            this.setState({
                rehabLocationValid: false,
            });
        }
    };

    checkValid = () => {
        const {
            step,
            guardianName,
            mobileNum,
            altMobileNum,
            guardianID,
            emailAddress,
            childName,
            residenceLoc,
            childID,
            rehabLocation,
            schoolName,
            who,
        } = this.state;
        if (step === 1) {
            this.validGuardianName();
            this.validMobileNum();
            this.validAltMobileNum();
            this.validEmailAddress();
            this.validGuardianID();
            if (
                name.test(guardianName) &&
                mobile.test(mobileNum) &&
                mobile.test(altMobileNum) &&
                email.test(emailAddress) &&
                id.test(guardianID)
            ) {
                this.setState({
                    isValid: true,
                });
                return true;
            } else {
                return false;
            }
        } else if (step === 2) {
            this.validChildName();
            this.validChildID();
            this.validResidenceLoc();
            if (
                name.test(childName) &&
                id.test(childID) &&
                name.test(residenceLoc)
            ) {
                this.setState({
                    isValid: true,
                });
                return true;
            } else {
                return false;
            }
        } else if (step === 3) {
            this.validWho();
            if (name.test(who)) {
                this.setState({
                    isValid: true,
                });
                return true;
            } else {
                return false;
            }
        } else if (step === 4) {
            // this.validRehabLoc();
            // this.validSchoolName();
            // if (
            //     (nameNumber.test(schoolName) && name.test(rehabLocation)) ||
            //     (schoolName === '' && rehabLocation === '')
            // ) {
            //     this.setState({
            //         isValid: true,
            //     });
            //     return true;
            // } else {
            //     return false;
            // }
            this.setState({
                isValid: true,
            });
            return true;
        }
    };

    nextStep = () => {
        this.checkNotEmpty();
        this.checkValid();
        if (this.checkNotEmpty() === true && this.checkValid() === true) {
            this.setState({
                step: this.state.step + 1,
                emptyField: false,
            });
        } else if (this.checkNotEmpty() === false) {
            this.setState({
                emptyField: true,
            });
        } else if (this.checkValid() === false) {
            this.setState({
                isValid: false,
            });
        }
    };
    next = () => {
        console.log(this.state);
        this.nextStep();
    };

    prev = () => {
        this.setState({
            step: this.state.step - 1,
        });
    };

    appendZeroes = (n) => {
        if (n <= 9) {
            return '0' + n;
        }
        return n;
    };

    send = (e) => {
        e.preventDefault();
        this.checkNotEmpty();
        this.checkValid();

        if (this.checkNotEmpty() === true && this.checkValid() === true) {
            let pref_communication = [];
            if (this.state.email === true) {
                pref_communication.push('email');
            }
            if (this.state.sms === true) {
                pref_communication.push('sms');
            }
            if (this.state.phone === true) {
                pref_communication.push('phone');
            }
            let income = `${this.state.salary[0]} - ${this.state.salary[1]}`;
            const { childBirth } = this.state;
            let childBirthdate = `${childBirth.year}-${childBirth.month}-${childBirth.day}`;
            this.setState({
                sendClicked: true,
            });

            // let formatted_date =
            //     this.state.date.getFullYear() +
            //     '-' +
            //     this.appendZeroes(this.state.date.getMonth() + 1) +
            //     '-' +
            //     this.appendZeroes(this.state.date.getDate());
            // console.log(formatted_date);

            fetch(`${api_url}/autism/items/child_form`, {
                method: 'POST',
                headers: {
                    // headers,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    guardian_name: this.state.guardianName,
                    guardian_id: this.state.guardianID,
                    mobile: this.state.mobileNum,
                    alt_mobile: this.state.altMobileNum,
                    email: this.state.emailAddress,
                    child_name: this.state.childName,
                    child_birth: this.state.date,
                    child_id: this.state.childID,
                    gender: this.state.genderOpt,
                    nationality: this.state.nationality,
                    family_size: this.state.familySize,
                    preffered_communication: pref_communication,
                    relation: this.state.relation,
                    hearing_checked: this.state.hearingCheckOpt,
                    hearing_result: this.state.hearingResultOpt,
                    bathroom_independent: this.state.restroomDependencyOpt,
                    rehab_services: this.state.currentServicesOpt,
                    residence_location: this.state.residenceLoc,
                    family_income: income,
                    autism_diagnosed: this.state.diagnosysOpt,
                    communication_type: this.state.comType,
                    rehab_city: this.state.rehabLocation,
                    rehab_location: this.state.rehabCity,
                    attends_school: this.state.attendingSchool,
                    school_location: this.state.schoolCity,
                    school_name: this.state.schoolName,
                    who_diagnosed: this.state.who,
                    child_age: this.state.childAge,
                    transportation: this.state.transportationOpt,
                    rehab_service_provided_at: this.state.serviceType,
                    guardian_nationality: this.state.guardianNationality,
                }),
            })
                .then((res) => res.json())
                .then((res) => {
                    console.log('Response', res);
                    this.setState({
                        send: true,
                        error: false,
                    });
                })
                .catch((err) => {
                    console.log('Error', err);
                    this.setState({
                        send: false,
                        error: true,
                    });
                    // console.log('err', err);
                });
        } else if (this.checkNotEmpty() === false) {
            this.setState({
                emptyField: true,
            });
        } else if (this.checkValid() === false) {
            this.setState({
                isValid: false,
            });
        }
    };

    checked = (e) => {
        this.setState({
            [e.target.name]: e.target.checked,
        });
    };

    onChildDateChange = (date) => {
        // let childBirthdate = JSON.stringify(
        //     `${date.year}-${date.month}-${date.day}`
        // );
        // this.setState({
        //     childBirth: `${date.year}-${date.month}-${date.day}`,
        // });
        var newObject = {};
        var keys = [];

        for (var key in date) {
            keys.push(key);
        }

        for (var i = keys.length - 1; i >= 0; i--) {
            var value = date[keys[i]];
            newObject[keys[i]] = value;
        }

        var str = '';
        for (var k in newObject) {
            if (newObject.hasOwnProperty(k)) {
                str += newObject[k] + '-';
            }
        }

        let child_birth = str.substring(0, str.length - 1);
        console.log(str.substring(0, str.length - 1));
        this.setState({
            childBirth: date,
            date: `${date.year}-${this.appendZeroes(date.month)}-${this.appendZeroes(date.day)}`,
        });
    };

    option = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
        switch (e.target.name) {
            case 'diagnosysOpt':
                this.setState({
                    diagnosysOptEmpty: false,
                });
                break;
            case 'hearingCheckOpt':
                this.setState({
                    hearingCheckEmpty: false,
                });
                break;
            case 'hearingResultOpt':
                this.setState({
                    hearingResultOptEmpty: false,
                });
                break;
            case 'restroomDependencyOpt':
                this.setState({
                    restroomDependencyOptEmpty: false,
                });
                break;
            case 'currentServicesOpt':
                this.setState({
                    currentServicesOptEmpty: false,
                });
                break;
            case 'attendingSchool':
                this.setState({
                    attendingSchoolEmpty: false,
                });
                break;
            case 'transportationOpt':
                this.setState({
                    transportationOptEmpty: false,
                });
                break;
            case 'guardianNationality':
                this.setState({
                    guardianNationalityEmpty: false,
                });
                break;
            case 'nationality':
                this.setState({
                    nationalityEmpty: false,
                });
                break;
            case 'genderOpt':
                this.setState({
                    genderOptEmpty: false,
                });
                break;
            default:
                console.log('Target not known');
        }
    };

    render() {
        const { t } = this.props;
        const { date, childBirth } = this.state;
        return (
            <>
                <div className='form' id='form'>
                    <Form className='child-form'>
                        {this.state.step === 1 ? (
                            <Form.Group controlId='firstStep'>
                                <Form.Row>
                                    <Col
                                        className={`${
                                            i18next.language === 'en'
                                                ? 'ml-0 mr-2em'
                                                : ''
                                        }`}
                                    >
                                        {this.state.guardianNameValid ===
                                        true ? (
                                            <Input
                                                type={'text'}
                                                label={`${t(
                                                    'register.child.formLabels.guardianName'
                                                )}`}
                                                name={'guardianName'}
                                                value={this.state.guardianName}
                                                empty={this.state.emptyField}
                                                onChange={this.onChangeHandler}
                                            />
                                        ) : (
                                            <InvalidInput
                                                type={'text'}
                                                label={`${t(
                                                    'register.child.formLabels.guardianName'
                                                )}`}
                                                name={'guardianName'}
                                                value={this.state.guardianName}
                                                empty={this.state.emptyField}
                                                onChange={this.onChangeHandler}
                                            />
                                        )}
                                    </Col>
                                    <Col
                                        className={`${
                                            i18next.language === 'en'
                                                ? 'ml-0 mr-2em'
                                                : ''
                                        }`}
                                    >
                                        {this.state.mobileNumValid === true ? (
                                            <Input
                                                type={'text'}
                                                label={`${t(
                                                    'register.child.formLabels.guardianMobNum'
                                                )}`}
                                                name={'mobileNum'}
                                                empty={this.state.emptyField}
                                                onChange={this.onChangeHandler}
                                                value={this.state.mobileNum}
                                            />
                                        ) : (
                                            <InvalidInput
                                                type={'text'}
                                                label={`${t(
                                                    'register.child.formLabels.guardianMobNum'
                                                )}`}
                                                name={'mobileNum'}
                                                empty={this.state.emptyField}
                                                onChange={this.onChangeHandler}
                                                value={this.state.mobileNum}
                                            />
                                        )}
                                    </Col>
                                </Form.Row>
                                <Form.Row>
                                    {i18next.language === 'ar' ? (
                                        <Col
                                            className={`${
                                                i18next.language === 'en'
                                                    ? 'ml-0 mr-2em'
                                                    : ''
                                            }`}
                                        >
                                            <Select
                                                options={relationType}
                                                onChange={this.onSelect}
                                                styles={
                                                    this.state.relationEmpty ===
                                                    true
                                                        ? dangerStyles
                                                        : colourStyles
                                                }
                                                className='react-select-container'
                                                classNamePrefix='react-select'
                                                placeholder={`${
                                                    this.state.relationLabel ===
                                                    ''
                                                        ? `${t(
                                                              'register.child.formLabels.relation'
                                                          )}`
                                                        : `${this.state.relationLabel}`
                                                }`}
                                            />
                                        </Col>
                                    ) : (
                                        <Col
                                            className={`${
                                                i18next.language === 'en'
                                                    ? 'ml-0 mr-2em'
                                                    : ''
                                            }`}
                                        >
                                            <Select
                                                options={en_relationType}
                                                onChange={this.onSelect}
                                                styles={
                                                    this.state.relationEmpty ===
                                                    true
                                                        ? dangerStyles
                                                        : colourStyles
                                                }
                                                className='react-select-container'
                                                classNamePrefix='react-select'
                                                placeholder={`${
                                                    this.state.relationLabel ===
                                                    ''
                                                        ? `${t(
                                                              'register.child.formLabels.relation'
                                                          )}`
                                                        : `${this.state.relationLabel}`
                                                }`}
                                            />
                                        </Col>
                                    )}
                                    <Col
                                        className={`${
                                            i18next.language === 'en'
                                                ? 'ml-0 mr-2em'
                                                : ''
                                        }`}
                                    >
                                        {this.state.altMobileNumValid ===
                                        true ? (
                                            <Input
                                                type={'text'}
                                                label={`${t(
                                                    'register.child.formLabels.guardianMobNumAlt'
                                                )}`}
                                                name={'altMobileNum'}
                                                value={this.state.altMobileNum}
                                                empty={this.state.emptyField}
                                                onChange={this.onChangeHandler}
                                            />
                                        ) : (
                                            <InvalidInput
                                                type={'text'}
                                                label={`${t(
                                                    'register.child.formLabels.guardianMobNumAlt'
                                                )}`}
                                                name={'altMobileNum'}
                                                value={this.state.altMobileNum}
                                                empty={this.state.emptyField}
                                                onChange={this.onChangeHandler}
                                            />
                                        )}
                                    </Col>
                                </Form.Row>
                                <Form.Row>
                                    <Col
                                        className={`${
                                            i18next.language === 'en'
                                                ? 'ml-0 mr-2em'
                                                : ''
                                        }`}
                                    >
                                        {this.state.guardianIDValid === true ? (
                                            <Input
                                                type={'text'}
                                                label={`${t(
                                                    'register.child.formLabels.guardianID'
                                                )}`}
                                                name={'guardianID'}
                                                empty={this.state.emptyField}
                                                onChange={this.onChangeHandler}
                                                value={this.state.guardianID}
                                            />
                                        ) : (
                                            <InvalidInput
                                                type={'text'}
                                                label={`${t(
                                                    'register.child.formLabels.guardianID'
                                                )}`}
                                                name={'guardianID'}
                                                empty={this.state.emptyField}
                                                onChange={this.onChangeHandler}
                                                value={this.state.guardianID}
                                            />
                                        )}
                                    </Col>
                                    <Col
                                        className={`${
                                            i18next.language === 'en'
                                                ? 'ml-0 mr-2em'
                                                : ''
                                        }`}
                                    >
                                        <Form.Label className='contact'>
                                            {`${t(
                                                'register.child.formLabels.prefCommunication'
                                            )}`}
                                        </Form.Label>
                                        <div
                                            key={`inline-checkbox`}
                                            className='mb-3'
                                        >
                                            <Form.Check
                                                inline
                                                label={`${t(
                                                    'register.child.formLabels.communication.email'
                                                )}`}
                                                type='checkbox'
                                                id={`inline-checkbox-1`}
                                                name='email'
                                                checked={this.state.email}
                                                onChange={this.checked}
                                            />
                                            <Form.Check
                                                inline
                                                label={`${t(
                                                    'register.child.formLabels.communication.sms'
                                                )}`}
                                                type='checkbox'
                                                id={`inline-checkbox-2`}
                                                name='sms'
                                                checked={this.state.sms}
                                                onChange={this.checked}
                                            />
                                            <Form.Check
                                                inline
                                                label={`${t(
                                                    'register.child.formLabels.communication.phone'
                                                )}`}
                                                type='checkbox'
                                                id={`inline-checkbox-3`}
                                                name='phone'
                                                checked={this.state.phone}
                                                onChange={this.checked}
                                            />
                                        </div>
                                    </Col>
                                </Form.Row>
                                <Form.Row>
                                    <Col
                                        className={`${
                                            i18next.language === 'en'
                                                ? 'ml-0 mr-2em'
                                                : ''
                                        }`}
                                    >
                                        {this.state.emailAddressValid ===
                                        true ? (
                                            <Input
                                                type={'text'}
                                                label={`${t(
                                                    'register.child.formLabels.email'
                                                )}`}
                                                name={'emailAddress'}
                                                empty={this.state.emptyField}
                                                onChange={this.onChangeHandler}
                                                value={this.state.emailAddress}
                                            />
                                        ) : (
                                            <InvalidInput
                                                type={'text'}
                                                label={`${t(
                                                    'register.child.formLabels.email'
                                                )}`}
                                                name={'emailAddress'}
                                                empty={this.state.emptyField}
                                                onChange={this.onChangeHandler}
                                                value={this.state.emailAddress}
                                            />
                                        )}
                                    </Col>
                                    <Col
                                        className={`${
                                            i18next.language === 'en'
                                                ? 'ml-0 mr-2em'
                                                : ''
                                        }`}
                                    >
                                        <Form.Label
                                            style={{
                                                color: `${
                                                    this.state
                                                        .guardianNationalityEmpty ===
                                                    true
                                                        ? 'red'
                                                        : ''
                                                }`,
                                            }}
                                        >
                                            {`${t(
                                                'register.child.formLabels.nationality'
                                            )}`}
                                        </Form.Label>
                                        <div
                                            key={`inline-radio`}
                                            className='mb-3'
                                        >
                                            <Form.Check
                                                inline
                                                label={`${t(
                                                    'register.child.formLabels.nationalityOptions.saudi'
                                                )}`}
                                                type='radio'
                                                id={`inline-radio-1`}
                                                value='saudi'
                                                name='guardianNationality'
                                                checked={
                                                    this.state
                                                        .guardianNationality ===
                                                    'saudi'
                                                }
                                                onChange={this.option}
                                            />
                                            <Form.Check
                                                inline
                                                label={`${t(
                                                    'register.child.formLabels.nationalityOptions.nonSaudi'
                                                )}`}
                                                type='radio'
                                                id={`inline-radio-2`}
                                                value='nonSaudi'
                                                name='guardianNationality'
                                                checked={
                                                    this.state
                                                        .guardianNationality ===
                                                    'nonSaudi'
                                                }
                                                onChange={this.option}
                                            />
                                        </div>
                                    </Col>
                                </Form.Row>
                                {this.state.emptyFirst === true ? (
                                    <p className='empty-msg'>{`${t(
                                        'empty'
                                    )}`}</p>
                                ) : (
                                    <></>
                                )}
                                {this.state.isValid === false ? (
                                    <p className='empty-msg'>{`${t(
                                        'invalid'
                                    )}`}</p>
                                ) : (
                                    <></>
                                )}
                            </Form.Group>
                        ) : (
                            <>
                                {this.state.step === 2 ? (
                                    <Form.Group controlId='firstStep'>
                                        <Form.Row>
                                            <Col
                                                className={`${
                                                    i18next.language === 'en'
                                                        ? 'ml-0 mr-2em'
                                                        : ''
                                                }`}
                                            >
                                                {this.state.childNameValid ===
                                                true ? (
                                                    <Input
                                                        type={'text'}
                                                        label={`${t(
                                                            'register.child.formLabels.childName'
                                                        )}`}
                                                        name={'childName'}
                                                        value={
                                                            this.state.childName
                                                        }
                                                        empty={
                                                            this.state
                                                                .emptyField
                                                        }
                                                        onChange={
                                                            this.onChangeHandler
                                                        }
                                                    />
                                                ) : (
                                                    <InvalidInput
                                                        type={'text'}
                                                        label={`${t(
                                                            'register.child.formLabels.childName'
                                                        )}`}
                                                        name={'childName'}
                                                        value={
                                                            this.state.childName
                                                        }
                                                        empty={
                                                            this.state
                                                                .emptyField
                                                        }
                                                        onChange={
                                                            this.onChangeHandler
                                                        }
                                                    />
                                                )}
                                            </Col>
                                            <Col
                                                className={`${
                                                    i18next.language === 'en'
                                                        ? 'ml-0 mr-2em'
                                                        : ''
                                                }`}
                                            >
                                                <div
                                                    className={`${
                                                        i18next.language ===
                                                        'ar'
                                                            ? 'tb-container'
                                                            : 'tb-container text-left ml-0'
                                                    }`}
                                                >
                                                    <input
                                                        className={`aumd-tb ${
                                                            this.state
                                                                .emptyField ===
                                                            true
                                                                ? 'aumd-tb-d'
                                                                : ''
                                                        }`}
                                                        id='familySize'
                                                        name='familySize'
                                                        type='number'
                                                        placeholder=' '
                                                        min='1'
                                                        value={
                                                            this.state
                                                                .familySize
                                                        }
                                                        onChange={
                                                            this.onChangeHandler
                                                        }
                                                    />
                                                    <label
                                                        className={`${
                                                            i18next.language ===
                                                            'ar'
                                                                ? 'aumd-tb-label'
                                                                : 'en-aumd-tb-label'
                                                        }`}
                                                        for='familySize'
                                                    >
                                                        {`${t(
                                                            'register.child.formLabels.familySize'
                                                        )}`}
                                                    </label>
                                                    <span
                                                        className={`validation ${
                                                            this.state
                                                                .emptyField ===
                                                            true
                                                                ? 'vd'
                                                                : ''
                                                        }`}
                                                    ></span>
                                                </div>
                                            </Col>
                                        </Form.Row>
                                        <Form.Row>
                                            <Col
                                                className={`${
                                                    i18next.language === 'en'
                                                        ? 'ml-0 mr-2em'
                                                        : ''
                                                }`}
                                            >
                                                <Form.Label
                                                    style={{
                                                        color: `${
                                                            this.state
                                                                .nationalityEmpty ===
                                                            true
                                                                ? 'red'
                                                                : ''
                                                        }`,
                                                    }}
                                                >
                                                    {`${t(
                                                        'register.child.formLabels.nationality'
                                                    )}`}
                                                </Form.Label>
                                                <div
                                                    key={`inline-radio`}
                                                    className='mb-3'
                                                >
                                                    <Form.Check
                                                        inline
                                                        label={`${t(
                                                            'register.child.formLabels.nationalityOptions.saudi'
                                                        )}`}
                                                        type='radio'
                                                        id={`inline-radio-1`}
                                                        value='saudi'
                                                        name='nationality'
                                                        checked={
                                                            this.state
                                                                .nationality ===
                                                            'saudi'
                                                        }
                                                        onChange={this.option}
                                                    />
                                                    <Form.Check
                                                        inline
                                                        label={`${t(
                                                            'register.child.formLabels.nationalityOptions.nonSaudi'
                                                        )}`}
                                                        type='radio'
                                                        id={`inline-radio-2`}
                                                        value='nonSaudi'
                                                        name='nationality'
                                                        checked={
                                                            this.state
                                                                .nationality ===
                                                            'nonSaudi'
                                                        }
                                                        onChange={this.option}
                                                    />
                                                </div>
                                            </Col>
                                            <Col
                                                className={`${
                                                    i18next.language === 'en'
                                                        ? 'ml-0 mr-2em'
                                                        : ''
                                                }`}
                                            >
                                                <div
                                                    className={`${
                                                        i18next.language ===
                                                        'ar'
                                                            ? 'ml-75'
                                                            : ''
                                                    } `}
                                                >
                                                    <Form.Label
                                                        style={{
                                                            color: `${
                                                                this.state
                                                                    .childBirthEmpty ===
                                                                true
                                                                    ? 'red'
                                                                    : ''
                                                            }`,
                                                        }}
                                                    >
                                                        {`${t(
                                                            'register.child.formLabels.childBirth'
                                                        )}`}
                                                    </Form.Label>
                                                    {/* <DatePicker
                                                        showDefaultIcon
                                                        placeholder='yyyy-mm-dd'
                                                        onChange={(e) =>
                                                            this.onDateChange(e)
                                                        }
                                                    /> */}

                                                    {/* <DatePicker
                                                        onChange={(e) =>
                                                            this.setState({
                                                                date: e,
                                                                childBirth: e,
                                                            })
                                                        }
                                                        value={this.state.date}
                                                    /> */}
                                                    {/* <DatePicker
                                                        date={this.state.date}
                                                        onDateChange={(e) =>
                                                            console.log(e)
                                                        }
                                                        locale={enGB}
                                                    >
                                                        {({
                                                            inputProps,
                                                            focused,
                                                        }) => (
                                                            <input
                                                                className={
                                                                    'input' +
                                                                    (focused
                                                                        ? ' -focused'
                                                                        : '')
                                                                }
                                                                {...inputProps}
                                                            />
                                                        )}
                                                    </DatePicker> */}
                                                    {/* <Flatpickr
                                                        placeholder='dd/mm/yyyy'
                                                        value={date}
                                                        onChange={(date) => {
                                                            console.log(date);
                                                            this.setState({
                                                                date,
                                                            });
                                                        }}
                                                        options={{
                                                            maxDate: 'today',
                                                            dateFormat: 'd-m-Y',
                                                        }}
                                                    /> */}

                                                    <DatePicker
                                                        value={
                                                            this.state
                                                                .childBirth
                                                        }
                                                        onChange={(date) => {
                                                            this.onChildDateChange(
                                                                date
                                                            );
                                                        }}
                                                        colorPrimary='#9c88ff' // added this
                                                        inputClassName='calendar_input'
                                                        maximumDate={utils().getToday()}
                                                        inputPlaceholder='yyyy/mm/dd'
                                                    />
                                                    {/* <Date /> */}
                                                </div>
                                            </Col>
                                        </Form.Row>
                                        <Form.Row>
                                            <Col
                                                className={`${
                                                    i18next.language === 'en'
                                                        ? 'ml-0 mr-2em'
                                                        : ''
                                                }`}
                                            >
                                                <Form.Label
                                                    style={{
                                                        color: `${
                                                            this.state
                                                                .genderOptEmpty ===
                                                            true
                                                                ? 'red'
                                                                : ''
                                                        }`,
                                                    }}
                                                >
                                                    {`${t(
                                                        'register.child.formLabels.gender'
                                                    )}`}
                                                </Form.Label>
                                                <div
                                                    key={`inline-radio`}
                                                    className='mb-3'
                                                >
                                                    <Form.Check
                                                        inline
                                                        label={`${t(
                                                            'register.child.formLabels.genderType.male'
                                                        )}`}
                                                        type='radio'
                                                        id={`inline-radio-1`}
                                                        value='male'
                                                        name='genderOpt'
                                                        checked={
                                                            this.state
                                                                .genderOpt ===
                                                            'male'
                                                        }
                                                        onChange={this.option}
                                                        // className='check'
                                                    />
                                                    <Form.Check
                                                        inline
                                                        label={`${t(
                                                            'register.child.formLabels.genderType.female'
                                                        )}`}
                                                        value='female'
                                                        name='genderOpt'
                                                        type='radio'
                                                        id={`inline-radio-2`}
                                                        checked={
                                                            this.state
                                                                .genderOpt ===
                                                            'female'
                                                        }
                                                        onChange={this.option}
                                                        // className='check'
                                                    />
                                                </div>
                                            </Col>
                                            <Col
                                                className={`${
                                                    i18next.language === 'en'
                                                        ? 'ml-0 mr-2em'
                                                        : ''
                                                }`}
                                            >
                                                {this.state.childIDValid ===
                                                true ? (
                                                    <Input
                                                        type={'text'}
                                                        label={`${t(
                                                            'register.child.formLabels.childID'
                                                        )}`}
                                                        name={'childID'}
                                                        value={
                                                            this.state.childID
                                                        }
                                                        empty={
                                                            this.state
                                                                .emptyField
                                                        }
                                                        onChange={
                                                            this.onChangeHandler
                                                        }
                                                    />
                                                ) : (
                                                    <InvalidInput
                                                        type={'text'}
                                                        label={`${t(
                                                            'register.child.formLabels.childID'
                                                        )}`}
                                                        name={'childID'}
                                                        value={
                                                            this.state.childID
                                                        }
                                                        empty={
                                                            this.state
                                                                .emptyField
                                                        }
                                                        onChange={
                                                            this.onChangeHandler
                                                        }
                                                    />
                                                )}
                                            </Col>
                                        </Form.Row>
                                        <Form.Row>
                                            <Col
                                                className={`${
                                                    i18next.language === 'en'
                                                        ? 'ml-0 mr-2em'
                                                        : ''
                                                }`}
                                            >
                                                {this.state
                                                    .residenceLocValid ===
                                                true ? (
                                                    <Input
                                                        type={'text'}
                                                        label={`${t(
                                                            'register.child.formLabels.residenceLoc'
                                                        )}`}
                                                        name={'residenceLoc'}
                                                        value={
                                                            this.state
                                                                .residenceLoc
                                                        }
                                                        empty={
                                                            this.state
                                                                .emptyField
                                                        }
                                                        onChange={
                                                            this.onChangeHandler
                                                        }
                                                    />
                                                ) : (
                                                    <InvalidInput
                                                        type={'text'}
                                                        label={`${t(
                                                            'register.child.formLabels.residenceLoc'
                                                        )}`}
                                                        name={'residenceLoc'}
                                                        value={
                                                            this.state
                                                                .residenceLoc
                                                        }
                                                        empty={
                                                            this.state
                                                                .emptyField
                                                        }
                                                        onChange={
                                                            this.onChangeHandler
                                                        }
                                                    />
                                                )}
                                            </Col>
                                            <Col
                                                className={`${
                                                    i18next.language === 'en'
                                                        ? 'ml-0 mr-2em'
                                                        : ''
                                                }`}
                                            >
                                                <Form.Label>
                                                    {`${t(
                                                        'register.child.formLabels.familyIncome'
                                                    )}`}
                                                </Form.Label>
                                                {i18next.language === 'ar' ? (
                                                    <Range
                                                        allowCross={false}
                                                        defaultValue={[
                                                            3500,
                                                            7000,
                                                        ]}
                                                        step={500}
                                                        max={70000}
                                                        onChange={
                                                            this.onIncomeChange
                                                        }
                                                        reverse
                                                    />
                                                ) : (
                                                    <Range
                                                        allowCross={false}
                                                        defaultValue={[
                                                            3500,
                                                            7000,
                                                        ]}
                                                        step={500}
                                                        max={70000}
                                                        onChange={
                                                            this.onIncomeChange
                                                        }
                                                    />
                                                )}

                                                <Form.Label>
                                                    {this.state.salary[0]} -{' '}
                                                    {this.state.salary[1]}
                                                </Form.Label>
                                            </Col>
                                        </Form.Row>
                                        {this.state.emptySecond === true ? (
                                            <p className='empty-msg'>
                                                {`${t('empty')}`}
                                            </p>
                                        ) : (
                                            <></>
                                        )}
                                        {this.state.isValid === false ? (
                                            <p className='empty-msg'>
                                                {`${t('invalid')}`}
                                            </p>
                                        ) : (
                                            <></>
                                        )}
                                    </Form.Group>
                                ) : (
                                    <>
                                        {this.state.step === 3 ? (
                                            <Form.Group controlId='thirdStep'>
                                                <Form.Row>
                                                    <Col
                                                        className={`${
                                                            i18next.language ===
                                                            'en'
                                                                ? 'ml-0 mr-2em'
                                                                : ''
                                                        }`}
                                                    >
                                                        <Form.Label
                                                            style={{
                                                                color: `${
                                                                    this.state
                                                                        .diagnosysOptEmpty ===
                                                                    true
                                                                        ? 'red'
                                                                        : ''
                                                                }`,
                                                            }}
                                                        >
                                                            {t(
                                                                'register.child.formLabels.diagnosed'
                                                            )}
                                                        </Form.Label>
                                                        <div
                                                            key={`inline-radio`}
                                                            className='mb-3'
                                                        >
                                                            <Form.Check
                                                                inline
                                                                label={`${t(
                                                                    'yes'
                                                                )}`}
                                                                type='radio'
                                                                id={`inline-radio-1`}
                                                                value='yes'
                                                                name='diagnosysOpt'
                                                                checked={
                                                                    this.state
                                                                        .diagnosysOpt ===
                                                                    'yes'
                                                                }
                                                                onChange={
                                                                    this.option
                                                                }
                                                                // className='check'
                                                            />
                                                            <Form.Check
                                                                inline
                                                                label={`${t(
                                                                    'no'
                                                                )}`}
                                                                type='radio'
                                                                id={`inline-radio-2`}
                                                                value='no'
                                                                name='diagnosysOpt'
                                                                checked={
                                                                    this.state
                                                                        .diagnosysOpt ===
                                                                    'no'
                                                                }
                                                                onChange={
                                                                    this.option
                                                                }
                                                                // className='check'
                                                            />
                                                        </div>
                                                    </Col>
                                                    {i18next.language ===
                                                    'ar' ? (
                                                        <Col
                                                            className={`${
                                                                i18next.language ===
                                                                'en'
                                                                    ? 'ml-0 mr-2em'
                                                                    : ''
                                                            }`}
                                                        >
                                                            <Form.Label>
                                                                {t(
                                                                    'register.child.formLabels.communicate'
                                                                )}
                                                            </Form.Label>
                                                            <Select
                                                                options={
                                                                    comOptns
                                                                }
                                                                onChange={
                                                                    this
                                                                        .onSelect
                                                                }
                                                                styles={
                                                                    this.state
                                                                        .comTypeEmpty ===
                                                                    true
                                                                        ? dangerStyles
                                                                        : colourStyles
                                                                }
                                                                className='react-select-container'
                                                                classNamePrefix='react-select'
                                                                placeholder={`${
                                                                    this.state
                                                                        .comTypeLabel ===
                                                                    ''
                                                                        ? `${t(
                                                                              'choose'
                                                                          )}`
                                                                        : `${this.state.comTypeLabel}`
                                                                }`}
                                                            />
                                                        </Col>
                                                    ) : (
                                                        <Col
                                                            className={`${
                                                                i18next.language ===
                                                                'en'
                                                                    ? 'ml-0 mr-2em'
                                                                    : ''
                                                            }`}
                                                        >
                                                            <Form.Label>
                                                                {t(
                                                                    'register.child.formLabels.communicate'
                                                                )}
                                                            </Form.Label>
                                                            <Select
                                                                options={
                                                                    en_comOptns
                                                                }
                                                                onChange={
                                                                    this
                                                                        .onSelect
                                                                }
                                                                styles={
                                                                    this.state
                                                                        .comTypeEmpty ===
                                                                    true
                                                                        ? dangerStyles
                                                                        : colourStyles
                                                                }
                                                                className='react-select-container'
                                                                classNamePrefix='react-select'
                                                                placeholder={`${
                                                                    this.state
                                                                        .comTypeLabel ===
                                                                    ''
                                                                        ? `${t(
                                                                              'choose'
                                                                          )}`
                                                                        : `${this.state.comTypeLabel}`
                                                                }`}
                                                            />
                                                        </Col>
                                                    )}
                                                </Form.Row>
                                                <Form.Row>
                                                    <Col
                                                        className={`${
                                                            i18next.language ===
                                                            'en'
                                                                ? 'ml-0 mr-2em'
                                                                : ''
                                                        }`}
                                                    >
                                                        {this.state.whoValid ===
                                                        true ? (
                                                            <Input
                                                                type={'text'}
                                                                label={t(
                                                                    'register.child.formLabels.who'
                                                                )}
                                                                name={'who'}
                                                                empty={
                                                                    this.state
                                                                        .emptyField
                                                                }
                                                                onChange={
                                                                    this
                                                                        .onChangeHandler
                                                                }
                                                                value={
                                                                    this.state
                                                                        .who
                                                                }
                                                            />
                                                        ) : (
                                                            <InvalidInput
                                                                type={'text'}
                                                                label={t(
                                                                    'register.child.formLabels.who'
                                                                )}
                                                                name={'who'}
                                                                empty={
                                                                    this.state
                                                                        .emptyField
                                                                }
                                                                onChange={
                                                                    this
                                                                        .onChangeHandler
                                                                }
                                                                value={
                                                                    this.state
                                                                        .who
                                                                }
                                                            />
                                                        )}
                                                    </Col>
                                                    <Col
                                                        className={`${
                                                            i18next.language ===
                                                            'en'
                                                                ? 'ml-0 mr-2em'
                                                                : ''
                                                        }`}
                                                    >
                                                        <Form.Label
                                                            style={{
                                                                color: `${
                                                                    this.state
                                                                        .restroomDependencyOptEmpty ===
                                                                    true
                                                                        ? 'red'
                                                                        : ''
                                                                }`,
                                                            }}
                                                        >
                                                            {t(
                                                                'register.child.formLabels.bathroom'
                                                            )}
                                                        </Form.Label>
                                                        <div
                                                            key={`inline-radio`}
                                                            className='mb-3'
                                                        >
                                                            <Form.Check
                                                                inline
                                                                label={`${t(
                                                                    'yes'
                                                                )}`}
                                                                type='radio'
                                                                id={`inline-radio-1`}
                                                                value='yes'
                                                                name='restroomDependencyOpt'
                                                                checked={
                                                                    this.state
                                                                        .restroomDependencyOpt ===
                                                                    'yes'
                                                                }
                                                                onChange={
                                                                    this.option
                                                                }
                                                                // className='check'
                                                            />
                                                            <Form.Check
                                                                inline
                                                                label={`${t(
                                                                    'no'
                                                                )}`}
                                                                type='radio'
                                                                id={`inline-radio-2`}
                                                                value='no'
                                                                name='restroomDependencyOpt'
                                                                checked={
                                                                    this.state
                                                                        .restroomDependencyOpt ===
                                                                    'no'
                                                                }
                                                                onChange={
                                                                    this.option
                                                                }
                                                                // className='check'
                                                            />
                                                            <Form.Check
                                                                inline
                                                                label={t(
                                                                    'somewhat'
                                                                )}
                                                                type='radio'
                                                                id={`inline-radio-3`}
                                                                value='somehow'
                                                                name='restroomDependencyOpt'
                                                                checked={
                                                                    this.state
                                                                        .restroomDependencyOpt ===
                                                                    'somehow'
                                                                }
                                                                onChange={
                                                                    this.option
                                                                }
                                                                // className='check'
                                                            />
                                                        </div>
                                                    </Col>
                                                </Form.Row>
                                                <Form.Row>
                                                    <Col
                                                        className={`${
                                                            i18next.language ===
                                                            'en'
                                                                ? 'ml-0 mr-2em'
                                                                : ''
                                                        }`}
                                                    >
                                                        <Form.Label
                                                            style={{
                                                                color: `${
                                                                    this.state
                                                                        .hearingCheckEmpty ===
                                                                    true
                                                                        ? 'red'
                                                                        : ''
                                                                }`,
                                                            }}
                                                        >
                                                            {t(
                                                                'register.child.formLabels.earCheck'
                                                            )}
                                                        </Form.Label>
                                                        <div
                                                            key={`inline-radio`}
                                                            className='mb-3'
                                                        >
                                                            <Form.Check
                                                                inline
                                                                label={`${t(
                                                                    'yes'
                                                                )}`}
                                                                type='radio'
                                                                id={`inline-radio-1`}
                                                                value='yes'
                                                                name='hearingCheckOpt'
                                                                checked={
                                                                    this.state
                                                                        .hearingCheckOpt ===
                                                                    'yes'
                                                                }
                                                                onChange={
                                                                    this.option
                                                                }
                                                            />
                                                            <Form.Check
                                                                inline
                                                                label={`${t(
                                                                    'no'
                                                                )}`}
                                                                type='radio'
                                                                id={`inline-radio-2`}
                                                                value='no'
                                                                name='hearingCheckOpt'
                                                                checked={
                                                                    this.state
                                                                        .hearingCheckOpt ===
                                                                    'no'
                                                                }
                                                                onChange={
                                                                    this.option
                                                                }
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col
                                                        className={`${
                                                            i18next.language ===
                                                            'en'
                                                                ? 'ml-0 mr-2em'
                                                                : ''
                                                        }`}
                                                    >
                                                        <div
                                                            className={`${
                                                                i18next.language ===
                                                                'ar'
                                                                    ? 'tb-container'
                                                                    : 'tb-container text-left ml-0'
                                                            }`}
                                                        >
                                                            <input
                                                                className={`aumd-tb ${
                                                                    this.state
                                                                        .emptyField ===
                                                                    true
                                                                        ? 'aumd-tb-d'
                                                                        : ''
                                                                }`}
                                                                id='childAge'
                                                                name='childAge'
                                                                type='number'
                                                                min={1}
                                                                placeholder=' '
                                                                onChange={
                                                                    this
                                                                        .onChangeHandler
                                                                }
                                                                value={
                                                                    this.state
                                                                        .childAge
                                                                }
                                                            />
                                                            <label
                                                                className={`${
                                                                    i18next.language ===
                                                                    'ar'
                                                                        ? 'aumd-tb-label'
                                                                        : 'en-aumd-tb-label'
                                                                }`}
                                                                for='childAge'
                                                            >
                                                                {t(
                                                                    'register.child.formLabels.age'
                                                                )}
                                                            </label>
                                                            <span
                                                                className={`validation ${
                                                                    this.state
                                                                        .emptyField ===
                                                                    true
                                                                        ? 'vd'
                                                                        : ''
                                                                }`}
                                                            >
                                                                valid
                                                            </span>
                                                        </div>
                                                        {/* <Input
                                                            type={'number'}
                                                            label={t(
                                                                'register.child.formLabels.age'
                                                            )}
                                                            name={'childAge'}
                                                            empty={
                                                                this.state
                                                                    .emptyField
                                                            }
                                                            onChange={
                                                                this
                                                                    .onChangeHandler
                                                            }
                                                            value={
                                                                this.state
                                                                    .childAge
                                                            }
                                                        /> */}
                                                    </Col>
                                                </Form.Row>
                                                <Form.Row>
                                                    <Col
                                                        className={`${
                                                            i18next.language ===
                                                            'en'
                                                                ? 'ml-0 mr-2em'
                                                                : ''
                                                        }`}
                                                    >
                                                        <Form.Label
                                                        // style={{
                                                        //     color: `${
                                                        //         this.state
                                                        //             .hearingResultOptEmpty ===
                                                        //         true
                                                        //             ? 'red'
                                                        //             : ''
                                                        //     }`,
                                                        // }}
                                                        >
                                                            {t(
                                                                'register.child.formLabels.earCheckResult'
                                                            )}
                                                        </Form.Label>
                                                        <div
                                                            key={`inline-radio`}
                                                            className='mb-3'
                                                        >
                                                            <Form.Check
                                                                inline
                                                                label={t(
                                                                    'register.child.formLabels.earCheckOptions.normal'
                                                                )}
                                                                type='radio'
                                                                id={`inline-radio-1`}
                                                                value='normal'
                                                                name='hearingResultOpt'
                                                                checked={
                                                                    this.state
                                                                        .hearingResultOpt ===
                                                                    'normal'
                                                                }
                                                                onChange={
                                                                    this.option
                                                                }
                                                                // className='check'
                                                            />
                                                            <Form.Check
                                                                inline
                                                                label={t(
                                                                    'register.child.formLabels.earCheckOptions.loss'
                                                                )}
                                                                type='radio'
                                                                id={`inline-radio-2`}
                                                                value='loss'
                                                                name='hearingResultOpt'
                                                                checked={
                                                                    this.state
                                                                        .hearingResultOpt ===
                                                                    'loss'
                                                                }
                                                                onChange={
                                                                    this.option
                                                                }
                                                                // className='check'
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col
                                                        className={`${
                                                            i18next.language ===
                                                            'en'
                                                                ? 'ml-0 mr-2em'
                                                                : ''
                                                        }`}
                                                    >
                                                        <Form.Label
                                                            style={{
                                                                color: `${
                                                                    this.state
                                                                        .transportationOptEmpty ===
                                                                    true
                                                                        ? 'red'
                                                                        : ''
                                                                }`,
                                                            }}
                                                        >
                                                            {t(
                                                                'register.child.formLabels.transportation'
                                                            )}
                                                        </Form.Label>
                                                        <div
                                                            key={`inline-radio`}
                                                            className='mb-3'
                                                        >
                                                            <Form.Check
                                                                inline
                                                                label={`${t(
                                                                    'yes'
                                                                )}`}
                                                                type='radio'
                                                                id={`inline-radio-1`}
                                                                value='yes'
                                                                name='transportationOpt'
                                                                checked={
                                                                    this.state
                                                                        .transportationOpt ===
                                                                    'yes'
                                                                }
                                                                onChange={
                                                                    this.option
                                                                }
                                                            />
                                                            <Form.Check
                                                                inline
                                                                label={`${t(
                                                                    'no'
                                                                )}`}
                                                                type='radio'
                                                                id={`inline-radio-2`}
                                                                value='no'
                                                                name='transportationOpt'
                                                                checked={
                                                                    this.state
                                                                        .transportationOpt ===
                                                                    'no'
                                                                }
                                                                onChange={
                                                                    this.option
                                                                }
                                                            />
                                                        </div>
                                                    </Col>
                                                </Form.Row>
                                                {this.state.emptyThird ===
                                                true ? (
                                                    <p className='empty-msg'>
                                                        {`${t('empty')}`}
                                                    </p>
                                                ) : (
                                                    <></>
                                                )}
                                                {this.state.isValid ===
                                                false ? (
                                                    <p className='empty-msg'>
                                                        {`${t('invalid')}`}
                                                    </p>
                                                ) : (
                                                    <></>
                                                )}
                                            </Form.Group>
                                        ) : (
                                            <Form.Group controlId='fourthStep'>
                                                <Form.Row>
                                                    <Col
                                                        className={`${
                                                            i18next.language ===
                                                            'en'
                                                                ? 'ml-0 mr-2em'
                                                                : ''
                                                        }`}
                                                    >
                                                        <Form.Label
                                                            style={{
                                                                color: `${
                                                                    this.state
                                                                        .currentServicesOptEmpty ===
                                                                    true
                                                                        ? 'red'
                                                                        : ''
                                                                }`,
                                                            }}
                                                        >
                                                            {`${t(
                                                                'register.child.formLabels.rehabServices'
                                                            )}`}
                                                        </Form.Label>
                                                        <div
                                                            key={`inline-radio`}
                                                            className='mb-3'
                                                        >
                                                            <Form.Check
                                                                inline
                                                                label={`${t(
                                                                    'yes'
                                                                )}`}
                                                                type='radio'
                                                                id={`inline-radio-1`}
                                                                value='yes'
                                                                name='currentServicesOpt'
                                                                checked={
                                                                    this.state
                                                                        .currentServicesOpt ===
                                                                    'yes'
                                                                }
                                                                onChange={
                                                                    this.option
                                                                }
                                                                // className='check'
                                                            />
                                                            <Form.Check
                                                                inline
                                                                label={`${t(
                                                                    'no'
                                                                )}`}
                                                                type='radio'
                                                                id={`inline-radio-2`}
                                                                value='no'
                                                                name='currentServicesOpt'
                                                                checked={
                                                                    this.state
                                                                        .currentServicesOpt ===
                                                                    'no'
                                                                }
                                                                onChange={
                                                                    this.option
                                                                }
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col
                                                        className={`${
                                                            i18next.language ===
                                                            'en'
                                                                ? 'ml-0 mr-2em'
                                                                : ''
                                                        }`}
                                                    >
                                                        <Form.Label
                                                            style={{
                                                                color: `${
                                                                    this.state
                                                                        .attendingSchoolEmpty ===
                                                                    true
                                                                        ? 'red'
                                                                        : ''
                                                                }`,
                                                            }}
                                                        >
                                                            {`${t(
                                                                'register.child.formLabels.attendingSchool'
                                                            )}`}
                                                        </Form.Label>
                                                        <div
                                                            key={`inline-radio`}
                                                            className='mb-3'
                                                        >
                                                            <Form.Check
                                                                inline
                                                                label={`${t(
                                                                    'yes'
                                                                )}`}
                                                                type='radio'
                                                                id={`inline-radio-1`}
                                                                value='yes'
                                                                name='attendingSchool'
                                                                checked={
                                                                    this.state
                                                                        .attendingSchool ===
                                                                    'yes'
                                                                }
                                                                onChange={
                                                                    this.option
                                                                }
                                                            />
                                                            <Form.Check
                                                                inline
                                                                label={`${t(
                                                                    'no'
                                                                )}`}
                                                                type='radio'
                                                                id={`inline-radio-2`}
                                                                value='no'
                                                                name='attendingSchool'
                                                                checked={
                                                                    this.state
                                                                        .attendingSchool ===
                                                                    'no'
                                                                }
                                                                onChange={
                                                                    this.option
                                                                }
                                                            />
                                                        </div>
                                                    </Col>
                                                </Form.Row>
                                                <Form.Row>
                                                    {i18next.language ===
                                                    'ar' ? (
                                                        <Col
                                                            className={`${
                                                                i18next.language ===
                                                                'en'
                                                                    ? 'ml-0 mr-2em'
                                                                    : ''
                                                            }`}
                                                        >
                                                            <Select
                                                                options={
                                                                    serviceOptions
                                                                }
                                                                onChange={
                                                                    this
                                                                        .onSelect
                                                                }
                                                                styles={
                                                                    colourStyles
                                                                }
                                                                className='react-select-container'
                                                                classNamePrefix='react-select'
                                                                // placeholder={`${t(
                                                                //     'register.child.formLabels.ifYes'
                                                                // )}`}
                                                                placeholder={`${
                                                                    this.state
                                                                        .serviceTypeLabel ===
                                                                    ''
                                                                        ? `${t(
                                                                              'register.child.formLabels.ifYes'
                                                                          )}`
                                                                        : `${this.state.serviceTypeLabel}`
                                                                }`}
                                                            />
                                                        </Col>
                                                    ) : (
                                                        <Col
                                                            className={`${
                                                                i18next.language ===
                                                                'en'
                                                                    ? 'ml-0 mr-2em'
                                                                    : ''
                                                            }`}
                                                        >
                                                            <Select
                                                                options={
                                                                    en_serviceOptions
                                                                }
                                                                onChange={
                                                                    this
                                                                        .onSelect
                                                                }
                                                                styles={
                                                                    colourStyles
                                                                }
                                                                className='react-select-container'
                                                                classNamePrefix='react-select'
                                                                placeholder={`${
                                                                    this.state
                                                                        .serviceTypeLabel ===
                                                                    ''
                                                                        ? `${t(
                                                                              'register.child.formLabels.ifYes'
                                                                          )}`
                                                                        : `${this.state.serviceTypeLabel}`
                                                                }`}
                                                            />
                                                        </Col>
                                                    )}
                                                    <Col
                                                        className={`${
                                                            i18next.language ===
                                                            'en'
                                                                ? 'ml-0 mr-2em'
                                                                : ''
                                                        }`}
                                                    >
                                                        <Input
                                                            type={'text'}
                                                            label={`${t(
                                                                'register.child.formLabels.school'
                                                            )}`}
                                                            name={'schoolName'}
                                                            value={
                                                                this.state
                                                                    .schoolName
                                                            }
                                                            onChange={
                                                                this
                                                                    .onChangeHandler
                                                            }
                                                            empty={
                                                                this.state
                                                                    .optional
                                                            }
                                                        />
                                                    </Col>
                                                </Form.Row>
                                                <Form.Row>
                                                    {i18next.language ===
                                                    'ar' ? (
                                                        <Col
                                                            className={`${
                                                                i18next.language ===
                                                                'en'
                                                                    ? 'ml-0 mr-2em'
                                                                    : ''
                                                            }`}
                                                        >
                                                            <Select
                                                                options={
                                                                    rehabCityOptns
                                                                }
                                                                onChange={
                                                                    this
                                                                        .onSelect
                                                                }
                                                                styles={
                                                                    colourStyles
                                                                }
                                                                className='react-select-container'
                                                                classNamePrefix='react-select'
                                                                placeholder={`${
                                                                    this.state
                                                                        .rehabCityLabel ===
                                                                    ''
                                                                        ? `${t(
                                                                              'register.child.formLabels.servicesLoc'
                                                                          )}`
                                                                        : `${this.state.rehabCityLabel}`
                                                                }`}
                                                            />
                                                        </Col>
                                                    ) : (
                                                        <Col
                                                            className={`${
                                                                i18next.language ===
                                                                'en'
                                                                    ? 'ml-0 mr-2em'
                                                                    : ''
                                                            }`}
                                                        >
                                                            <Select
                                                                options={
                                                                    en_rehabCityOptns
                                                                }
                                                                onChange={
                                                                    this
                                                                        .onSelect
                                                                }
                                                                styles={
                                                                    colourStyles
                                                                }
                                                                className='react-select-container'
                                                                classNamePrefix='react-select'
                                                                placeholder={`${
                                                                    this.state
                                                                        .rehabCityLabel ===
                                                                    ''
                                                                        ? `${t(
                                                                              'register.child.formLabels.servicesLoc'
                                                                          )}`
                                                                        : `${this.state.rehabCityLabel}`
                                                                }`}
                                                            />
                                                        </Col>
                                                    )}
                                                    {i18next.language ===
                                                    'ar' ? (
                                                        <Col
                                                            className={`${
                                                                i18next.language ===
                                                                'en'
                                                                    ? 'ml-0 mr-2em'
                                                                    : ''
                                                            }`}
                                                        >
                                                            <Select
                                                                options={
                                                                    schoolCityOptns
                                                                }
                                                                onChange={
                                                                    this
                                                                        .onSelect
                                                                }
                                                                styles={
                                                                    colourStyles
                                                                }
                                                                className='react-select-container'
                                                                classNamePrefix='react-select'
                                                                placeholder={`${
                                                                    this.state
                                                                        .schoolCityLabel ===
                                                                    ''
                                                                        ? `${t(
                                                                              'register.child.formLabels.schoolLoc'
                                                                          )}`
                                                                        : `${this.state.schoolCityLabel}`
                                                                }`}
                                                            />
                                                        </Col>
                                                    ) : (
                                                        <Col
                                                            className={`${
                                                                i18next.language ===
                                                                'en'
                                                                    ? 'ml-0 mr-2em'
                                                                    : ''
                                                            }`}
                                                        >
                                                            <Select
                                                                options={
                                                                    en_schoolCityOptns
                                                                }
                                                                onChange={
                                                                    this
                                                                        .onSelect
                                                                }
                                                                styles={
                                                                    colourStyles
                                                                }
                                                                className='react-select-container'
                                                                classNamePrefix='react-select'
                                                                placeholder={`${
                                                                    this.state
                                                                        .schoolCityLabel ===
                                                                    ''
                                                                        ? `${t(
                                                                              'register.child.formLabels.schoolLoc'
                                                                          )}`
                                                                        : `${this.state.schoolCityLabel}`
                                                                }`}
                                                            />
                                                        </Col>
                                                    )}
                                                </Form.Row>
                                                <Form.Row>
                                                    <Col
                                                        className={`${
                                                            i18next.language ===
                                                            'en'
                                                                ? 'ml-0 mr-2em'
                                                                : ''
                                                        }`}
                                                    >
                                                        <Input
                                                            type={'text'}
                                                            label={`${t(
                                                                'register.child.formLabels.city'
                                                            )}`}
                                                            name={
                                                                'rehabLocation'
                                                            }
                                                            value={
                                                                this.state
                                                                    .rehabLocation
                                                            }
                                                            onChange={
                                                                this
                                                                    .onChangeHandler
                                                            }
                                                            empty={
                                                                this.state
                                                                    .optional
                                                            }
                                                        />
                                                    </Col>
                                                    <Col
                                                        className={`${
                                                            i18next.language ===
                                                            'en'
                                                                ? 'ml-0 mr-2em'
                                                                : ''
                                                        }`}
                                                    ></Col>
                                                </Form.Row>

                                                {this.state.emptyFourth ===
                                                true ? (
                                                    <p className='empty-msg'>
                                                        {`${t('empty')}`}
                                                    </p>
                                                ) : (
                                                    <></>
                                                )}
                                                {this.state.isValid ===
                                                false ? (
                                                    <p className='empty-msg'>
                                                        {`${t('invalid')}`}
                                                    </p>
                                                ) : (
                                                    <></>
                                                )}
                                            </Form.Group>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                    </Form>
                </div>
                <Stepper
                    title={this.state.title}
                    step={this.state.step}
                    pageEnd={this.state.pageEnd}
                    done={this.state.done}
                    left={this.state.left}
                    next={this.next}
                    prev={this.prev}
                    send={this.send}
                    canSend={this.state.send}
                    error={this.state.error}
                    clicked={this.state.sendClicked}
                    sendEnable={this.sendEnable}
                />
            </>
        );
    }
}

export default withTranslation()(Child);
